'use client';

import _ from 'lodash';
import { useEffect } from 'react';

import { Breadcrumbs } from 'components/atomic/atoms';
import { ProductDetailPageTemplate } from 'components/atomic/template';
import { useUIContext } from 'components/context/uiContext/ManagedUiContext';
import StandardLayout from 'components/layout/StandardLayout';
import { captureGTMEventViewItem } from 'lib/gtm';
import { getSelectedCart } from 'services/cart.service';
import { getCartDetailById } from 'services/hostCart.service';

const Product = ({ product, breadCrumbs }) => {
  const { authUser, updateCartInPortalHeader } = useUIContext();

  const currentSelectedCart = getSelectedCart();

  const updateCartItemCount = async () => {
    if (currentSelectedCart.id) {
      const { entity } = await getCartDetailById({
        cartId: currentSelectedCart.id
      });

      updateCartInPortalHeader(entity);
    }
  };

  useEffect(() => {
    currentSelectedCart && updateCartItemCount();
    if (product) {
      const {
        availableDiscount,
        categories,
        id = '',
        name,
        price: { price },
        productMedia = [],
        type
      } = product;

      captureGTMEventViewItem({
        availableDiscount,
        categories,
        id,
        name,
        price,
        productMedia,
        type
      });
    }
  }, []);

  // TODO: Hardik pair with Harsh - instead of empty page show product not found, page not found or something like that
  if (_.isEmpty(product)) {
    return '';
  }

  return (
    <StandardLayout
      headParameters={{
        showFooter: true
      }}
    >
      <div className='md:px-20 md:mt-8 hidden md:block'>
        <Breadcrumbs {...{ breadCrumbs }} />
      </div>
      <ProductDetailPageTemplate
        {...{
          authUser,
          product
        }}
      />
    </StandardLayout>
  );
};

export default Product;
